<template>
  <section class="py-14 lg:py-20 bg-[#f7f7f7]" aria-labelledby="spotlight-heading">
    <div class="max-w-screen-xl mx-auto px-6">

      <SectionHeader
        eyebrow="Uitgelicht"
        title="Populaire keuzes dit seizoen"
        heading-id="spotlight-heading"
      />

      <ul class="grid grid-cols-1 lg:grid-cols-2 gap-6 list-none p-0 m-0" role="list">
        <li
          v-for="card in spotlight"
          :key="card.slug"
          class="group relative rounded-[16px] overflow-hidden min-h-[340px] flex items-end"
        >
          <!-- Achtergrondafbeelding -->
          <img
            :src="sized(card.image, 640)"
            :srcset="srcset(card.image, 640)"
            sizes="(max-width: 1024px) 100vw, 50vw"
            :alt="card.imageAlt"
            width="600" height="400"
            loading="lazy" decoding="async"
            class="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-[500ms]"
          />

          <!-- Gradient overlay -->
          <div class="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-transparent"></div>

          <!-- Content -->
          <div class="relative z-10 p-8 w-full">
            <div class="flex items-center gap-2 mb-3 flex-wrap">
              <span class="inline-block text-[0.75rem] font-bold tracking-[0.08em] uppercase text-[#FFD500] bg-white/10 backdrop-blur-sm px-3 py-1 rounded-full">
                {{ card.badge }}
              </span>
              <span v-if="card.urgency" class="inline-flex items-center gap-1 text-[0.72rem] font-semibold bg-black/40 backdrop-blur-sm text-white px-2.5 py-1 rounded-full">
                <span class="w-1.5 h-1.5 bg-orange-400 rounded-full animate-pulse"></span>
                {{ card.urgency }}
              </span>
            </div>
            <h3 class="text-[1.5rem] font-black text-white leading-[1.2] mb-2">{{ card.title }}</h3>
            <p class="text-[0.9375rem] text-white/80 mb-5 max-w-[380px]">{{ card.body }}</p>
            <div class="flex items-center gap-3 flex-wrap">
              <router-link
                :to="`/categorie/${card.slug}`"
                :aria-label="`Bekijk ${card.title}`"
                class="inline-flex items-center gap-2 bg-[#FFD500] hover:bg-[#ffb800] text-[#111] font-bold text-[0.9375rem] px-5 py-[0.65rem] rounded-[6px] no-underline transition-all duration-200 hover:-translate-y-[1px] focus-visible:outline-[3px] focus-visible:outline-[#FFD500] focus-visible:outline-offset-4"
              >
                Bekijk nu
                <i class="bi bi-arrow-right text-[1rem]" aria-hidden="true"></i>
              </router-link>
              <span v-if="card.stat" class="text-[0.8rem] text-white/60 font-medium">{{ card.stat }}</span>
            </div>
          </div>
        </li>
      </ul>

    </div>
  </section>
</template>

<script setup>
import SectionHeader from './SectionHeader.vue'

// Sized WebP via de media-proxy voor interne /wp-content-afbeeldingen
const sized  = (url, w) => (url && url.startsWith('/wp-content')) ? `${url}?w=${w}` : url
const srcset = (url, w) => (url && url.startsWith('/wp-content'))
  ? `${url}?w=${w} 1x, ${url}?w=${w * 2} 2x` : null

const spotlight = [
  {
    slug: 'zonnepanelen',
    badge: 'Bestseller',
    urgency: '47 mensen bekijken dit nu',
    stat: '⭐ 4,9 / 5 op 380 reviews',
    title: 'Balkon zonnepanelen set',
    body: 'Compleet plug & play pakket voor op je balkon of terras. Installatie in 30 minuten, direct besparen.',
    image: '/wp-content/uploads/2026/07/balkonpanelen_met_batterij.png',
    imageAlt: 'Zonnepanelen op balkon',
  },
  {
    slug: 'laadpalen',
    badge: 'Nieuw',
    urgency: 'Bestel voor 15:00 → morgen in huis',
    stat: null,
    title: 'Slimme thuislader',
    body: 'Laad je EV slim op met dynamische tarieven. Volledig App-gestuurd, compatible met alle EV\'s.',
    image: '/wp-content/uploads/2026/07/slimme-thuisladers.png',
    imageAlt: 'Slimme laadpaal thuis',
  },
]
</script>
